import { render, staticRenderFns } from "./AddTecnico.vue?vue&type=template&id=4b53b5de"
import script from "./AddTecnico.vue?vue&type=script&lang=js"
export * from "./AddTecnico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports